import SwitchUserButton from './SwitchUserButton';
import LastLoginTimeStamp from './LastLoginTimestamp';
import IntroduceToColleagueLink from './IntroduceToColleagueLink';
import ConfigureBrowserLink from './ConfigureBrowserLink';
import { useWidgetContext } from '../context/WidgetContext';

export default function ExtrasSection() {
  const {
    athenaOneWebSessionTimedOut,
    athenaOneWebSso,
    athenaOneWebNonSsoTimedOut,
    athenaOneParams,
  } = useWidgetContext();

  if (athenaOneWebSso && (athenaOneParams?.BANNERTYPE === 'ERROR' || athenaOneParams?.BANNERTYPE === 'LOGOUT')) return <></>;

  // In the second step of non SSO reauth, Switch User must not be shown because the user has already
  // chosen to proceed with self.
  const isInsideReauthPopup =
    !!athenaOneWebSessionTimedOut &&
    !athenaOneWebNonSsoTimedOut &&
    typeof window !== 'undefined' &&
    !!window.opener;

  return (
    <>
      {
        ( athenaOneWebSessionTimedOut || athenaOneWebSso ) ?
          <>
            { !isInsideReauthPopup && <SwitchUserButton /> }
            <LastLoginTimeStamp />
          </>
          :
          <>
            <IntroduceToColleagueLink />
            <ConfigureBrowserLink />
          </>
      }
    </>
  );
}
